export const tipRecurrringFor = ['meshulam']

export const feeInstallmentFor = ['stripe', 'cardknox']

export default { tipRecurrringFor }
